import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import Breadcrumbs from 'shared/lib/components/controls/breadcrumbs/breadcrumbs';
import { useNavigate } from 'react-router-dom';
import BreadcrumbsItem from 'shared/lib/components/controls/breadcrumbs/breadcrumbsItem';
import PageWrapper from 'shared/lib/components/containers/pageWrapper';
import ColumnCenterFlex from 'shared/lib/components/containers/columnCenterFlex';
import { Box } from '@mui/material';
import PagePaddingWrapper from 'shared/lib/components/containers/pagePaddingWrapper';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useExplorerStore } from 'app/hooks/useExplorerStore';
import TrashExplorerSection from 'pages/trashExplorerPage/section/trashExplorerSection';
import { useTranslation } from 'react-i18next';
import TrashExplorerFolder from 'pages/trashExplorerPage/folder/trashExplorerFolder';
import { useEntityPath } from 'app/hooks/useEntityPath';
import { map } from 'lodash-es';
import { ExplorerEntityTypes } from 'entities/types';

export default observer(function TrashExplorerPage() {
  const navigate = useNavigate();
  const searchUtils = useSearchParamsUtils();
  const { t } = useTranslation();

  const { mobxStore } = useContext(MobxContext);

  const { getSectionSearchParams, getFolderSearchParams } = searchUtils;

  const currentEntity = useExplorerStore(mobxStore.trashExplorerStore);

  const path = useEntityPath(
    currentEntity
      ? {
          id: currentEntity.model.id,
          type: currentEntity.type,
          name: currentEntity?.model.data?.name || '',
        }
      : null
  );

  return (
    <PageWrapper>
      <PagePaddingWrapper
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box>
          <Breadcrumbs>
            <BreadcrumbsItem
              onClick={() => {
                navigate('/', { replace: false });
              }}
              title={t('breadcrumbs.main')}
            >
              {t('breadcrumbs.main')}
            </BreadcrumbsItem>

            <BreadcrumbsItem
              onClick={() => {
                navigate('/trash', { replace: false });
              }}
              title={t('common.trash')}
            >
              {t('common.trash')}
            </BreadcrumbsItem>

            {path.sectionMeta ? (
              <BreadcrumbsItem
                key={path.sectionMeta.id}
                onClick={() => {
                  navigate({
                    search: getSectionSearchParams({
                      sectionId: path.sectionMeta!.id,
                    }),
                  });
                }}
                title={path.sectionMeta.name}
              >
                {path.sectionMeta.name}
              </BreadcrumbsItem>
            ) : null}

            {path.foldersMeta
              ? map(path.foldersMeta, (item) => (
                  <BreadcrumbsItem
                    key={item.id}
                    onClick={() => {
                      navigate({
                        search: getFolderSearchParams({
                          folderId: item.id,
                        }),
                      });
                    }}
                    title={item.name}
                  >
                    {item.name}
                  </BreadcrumbsItem>
                ))
              : null}
          </Breadcrumbs>
        </Box>

        <ColumnCenterFlex>
          {currentEntity?.type === ExplorerEntityTypes.SECTION ? (
            <TrashExplorerSection
              sectionModel={currentEntity.model}
            ></TrashExplorerSection>
          ) : null}
          {currentEntity?.type === ExplorerEntityTypes.FOLDER ? (
            <TrashExplorerFolder
              folderModel={currentEntity.model}
            ></TrashExplorerFolder>
          ) : null}
        </ColumnCenterFlex>
      </PagePaddingWrapper>
    </PageWrapper>
  );
});
